import {WriteButton} from '../../common/buttons/WriteActions';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,} from "@mui/material";
import {useState} from "react";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    recipeName: string;
    onDelete: () => void;
    error?: string;
}

export const DeleteRecipeDialog = ({
                                       open,
                                       onClose,
                                       recipeName,
                                       onDelete, error,
                                   }: Props) => {
    const {t} = useAppTranslation();
    const [confirmationText, setConfirmationText] = useState("");

    const isValid =
        confirmationText.trim() === recipeName.trim();

    const handleClose = () => {
        setConfirmationText("");
        onClose();
    };

    const handleDelete = () => {
        onDelete();
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{t('recipes:delete_recipe')}</DialogTitle>

            <DialogContent>
                <Typography sx={{mb: 2}}>
                    {t('recipes:delete_recipe_confirmation')}
                </Typography>

                <Typography
                    color="error"
                    fontWeight={600}
                    sx={{mb: 2}}
                >
                    {recipeName}
                </Typography>

                <TextField
                    fullWidth
                    label={t('recipes:recipe_name')}
                    value={confirmationText}
                    onChange={(e) =>
                        setConfirmationText(e.target.value)
                    }
                />
                {error && <Alert severity="error" sx={{mt: 2}}>{error}</Alert>}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>
                    {t('common:cancel')}
                </Button>

                <WriteButton
                    color="error"
                    variant="contained"
                    disabled={!isValid}
                    onClick={handleDelete}
                >
                    {t('common:delete')}
                </WriteButton>
            </DialogActions>
        </Dialog>
    );
};
